import { MainShape, ProductFooter } from '@adtech/ui';
import { useCopy } from '@hooks/useCopy';
import { useGetAdvAccountInfoQuery } from '@redux/api/advApi';
import { Button, Loader } from '@sberlab/core-components';
import { IconCopy16, IconExternalLink20, IconLinkRetargeting64, IconZeroMagicBonuses64 } from '@sberlab/core-icons';
import React, { useState } from 'react';
import DocumentTitle from 'react-document-title';
import { useSearchParams } from 'react-router-dom';
import './AdsInfo.less';

const AdsInfo: React.FC = () => {
  const [searchParams] = useSearchParams();
  const ad = searchParams.get('ad');

  const {
    data: adInfo,
    isLoading,
    error,
  } = useGetAdvAccountInfoQuery(ad || '', {
    skip: !ad,
  });

  const { copyToClipboard } = useCopy();
  const [showCopyToast, setShowCopyToast] = useState(false);

  const handleCopyClick = async () => {
    const success = await copyToClipboard(adInfo.erid);
    if (success) {
      setShowCopyToast(true);
      setTimeout(() => {
        setShowCopyToast(false);
      }, 2000);
    }
  };

  return (
    <DocumentTitle title="Информация о рекламодателе">
      <div className="ads-info">
        <div className="ads-info__header">
          <MainShape
            additionalLogo="РЕКЛАМНАЯ ПЛАТФОРМА"
            isNotification={false}
            isNotificationMobile={false}
            isProfileDropdown={false}
          />
        </div>
        <div className="ads-info__content">
          <div className="ads-info__container">
            <Loader loading={isLoading}>
              {adInfo && (
                <>
                  <div className="ads-info__card">
                    <div className="ads-info__icon">
                      <IconLinkRetargeting64 size="48" />
                    </div>
                    <div className="ads-info__info">
                      <div className="ads-info__title">Информация об объекте рекламирования</div>
                      {adInfo.url && (
                        <div className="ads-info__label">
                          <Button
                            className="ads-info__link-button"
                            href={adInfo.url}
                            suffixIcon={
                              <IconExternalLink20
                                className="ads-info__icon-external"
                                size="20"
                              />
                            }
                            sx="small"
                            target="_blank"
                            view="link"
                          >
                            Посмотреть объект рекламы
                          </Button>
                        </div>
                      )}
                      {adInfo.erid && (
                        <>
                          <div className="ads-info__label">ERID</div>
                          <div
                            className="ads-info__text ads-info__erid"
                            onClick={handleCopyClick}
                          >
                            {adInfo.erid} &nbsp;
                            <IconCopy16 size="16" />
                          </div>
                        </>
                      )}
                      {adInfo.disclaimer && (
                        <>
                          <div className="ads-info__label">Дисклеймер</div>
                          <div className="ads-info__text">{adInfo.disclaimer}</div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className="ads-info__card">
                    <div className="ads-info__icon">
                      <IconZeroMagicBonuses64 size="48" />
                    </div>
                    <div className="ads-info__info">
                      <div className="ads-info__title">Информация о рекламодателе</div>
                      <div className="ads-info__about">
                        {adInfo.adv_name && (
                          <div className="ads-info__about__item">
                            <div className="ads-info__about__label">Рекламодатель</div>
                            <div className="ads-info__about__text">{adInfo.adv_name}</div>
                          </div>
                        )}
                        {adInfo.inn && (
                          <div className="ads-info__about__item">
                            <div className="ads-info__about__label">ИНН</div>
                            <div className="ads-info__about__text">{adInfo.inn}</div>
                          </div>
                        )}
                        {adInfo.details && (
                          <div className="ads-info__about__item">
                            <div className="ads-info__about__label">Реквизиты</div>
                            <div className="ads-info__about__text">{adInfo.details}</div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
              {error && (
                <div className="ads-info__card">
                  <div className="ads-info__icon">
                    <IconLinkRetargeting64 size="48" />
                  </div>
                  <div className="ads-info__info">
                    <div className="ads-info__title">Ошибка загрузки данных</div>
                  </div>
                </div>
              )}
              {!adInfo && !isLoading && !error && (
                <div className="ads-info__card">
                  <div className="ads-info__icon">
                    <IconLinkRetargeting64 size="48" />
                  </div>
                  <div className="ads-info__info">
                    <div className="ads-info__title">Рекламодатель не найден</div>
                  </div>
                </div>
              )}
            </Loader>
          </div>
          <ProductFooter />
        </div>
        {showCopyToast && <div className="ads-info__toast">Скопировано</div>}
      </div>
    </DocumentTitle>
  );
};

export default AdsInfo;
